const hasPortfolioState = (value) => Array.isArray(value?.portfolioReducer?.portfolio);

const parseState = (value) => {
  if (typeof value !== 'string') return undefined;

  try {
    const parsed = JSON.parse(value);
    return hasPortfolioState(parsed) ? parsed : undefined;
  } catch {
    return undefined;
  }
};

/** Read the primary state and its safety copy without mutating either key. */
export const loadStateSnapshot = (storage = localStorage) => {
  let rawState = null;
  let rawBackup = null;

  try {
    rawState = storage.getItem('state');
    rawBackup = storage.getItem('_stateBackup1');
  } catch {
    return { state: undefined, source: 'none', rawState, rawBackup };
  }

  const primaryState = parseState(rawState);
  if (primaryState) {
    return { state: primaryState, source: 'primary', rawState, rawBackup };
  }

  const backupState = parseState(rawBackup);
  if (backupState) {
    return { state: backupState, source: 'backup', rawState, rawBackup };
  }

  return { state: undefined, source: 'none', rawState, rawBackup };
};

export const loadState = () => loadStateSnapshot().state;

export const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('state', serializedState);
  } catch (err) {
    console.log(err);
  }
};
